import { useState } from 'react';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Box, Button, Stack, useTheme } from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import RowContainer from './components/RowContainer';
import RowContent from './components/RowContent';
import SectionTitle from './components/SectionTitle';

interface Props {
  studentGrade: number;
  studentGender: number;
  register: UseFormRegister<FieldValues>;
  isConfirmPassword: boolean;
  onConfirmPassword: () => void;
}

function Contents2(props: Props) {
  const { palette } = useTheme();

  const fluid = [
    [
      {
        label: '0.9%NS, 5%DS',
        link: 'https://www.youtube.com/watch?v=elrImpcb-ZY&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=8',
      },
      {
        label: 'HS, HD',
        link: 'https://www.youtube.com/watch?v=IJSIs-yFZHQ&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=9',
      },
      {
        label: 'DW',
        link: 'https://www.youtube.com/watch?v=mCKmttSo1Z4&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=10',
      },
    ],
    [
      {
        label: '알부민, 플라스마솔루션',
        link: 'https://www.youtube.com/watch?v=d49un6Ocnz4&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=11',
      },
      {
        label: '영양제, TPN',
        link: 'https://www.youtube.com/watch?v=7P63_oxfjsg&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=12',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  const EKG = [
    [
      {
        label: '전극 부착, 주의 사항 등',
        link: 'https://www.youtube.com/watch?v=XtcXNPKDxw4&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=28',
      },
      {
        label: '표준유도, 탈분극, 재분극',
        link: 'https://www.youtube.com/watch?v=43EHz_ZRmCA&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=29',
      },
      {
        label: '흉부 유도, V1~V6',
        link: 'https://www.youtube.com/watch?v=nvzgVcOMv98&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=30',
      },
    ],
    [
      {
        label: '심전도 파형의 형성 과정',
        link: 'https://www.youtube.com/watch?v=nIYF1RFBzk0&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=31',
      },
      {
        label: '질환별 심전도 그래프 변화',
        link: 'https://www.youtube.com/watch?v=HUtx5sz9lF0&list=PLVnfLGLhl7_B1aKIc4MD8hTom4wGw5UrL&index=32',
      },
      {
        label: '',
        link: '',
      },
    ],
  ];

  return (
    <Box sx={{ margin: '40px' }}>
      <SectionTitle title="수액" />

      <RowContainer xs={12} marginBottom={'30px'}>
        <RowContent title="">
          {fluid.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>

      <SectionTitle title="심전도" />

      <RowContainer xs={12} marginBottom={'30px'}>
        <RowContent title="">
          {EKG.map(item => {
            return (
              <Stack spacing={3} sx={{ mt: 2 }} direction="row">
                <Button
                  onClick={() => window.open(item[0].link)}
                  disabled={item[0].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[0].label}
                </Button>
                <Button
                  onClick={() => window.open(item[1].link)}
                  disabled={item[1].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[1].label}
                </Button>
                <Button
                  onClick={() => window.open(item[2].link)}
                  disabled={item[2].label === '' ? true : false}
                  color="inherit"
                  size="large"
                  fullWidth
                  sx={{
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    ':hover': {
                      backgroundColor: `${palette.primary.main}`,
                      color: 'white',
                      boxShadow: ' 2px 2px 2px 2px lightGray;',
                    },
                    boxShadow: ' 2px 2px 2px 2px lightGray;',
                  }}
                >
                  {item[2].label}
                </Button>
              </Stack>
            );
          })}
        </RowContent>
      </RowContainer>
    </Box>
  );
}

export default Contents2;
